//client/src/pages/user/OrderHistory.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function OrderHistory() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("all");

  useEffect(() => {
    api.get("/user/orders").then((res) => setOrders(res.data || []));
  }, []);

  const filtered =
    status === "all"
      ? orders
      : orders.filter((o) => o.status === status);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Order History</h1>

      <select
        className="input-glass max-w-xs bg-[#0b0f17] text-white"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="all">All</option>
        <option value="pending">Pending</option>
        <option value="processing">Processing</option>
        <option value="completed">Completed</option>
        <option value="cancelled">Cancelled</option>
      </select>

      <div className="card-glass overflow-x-auto">
        <table className="table-glass">
          <thead>
            <tr>
              <th>ID</th>
              <th>Service</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-6 text-gray-400">
                  No orders
                </td>
              </tr>
            ) : (
              filtered.map((o) => (
                <tr key={o._id}>
                  <td>#{o._id.slice(-6)}</td>
                  <td>{o.service?.name}</td>
                  <td>
                    <span className={`chip chip-${o.status}`}>
                      {o.status}
                    </span>
                  </td>
                  <td>₹{o.amount}</td>
                  <td>{new Date(o.createdAt).toLocaleString()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
